
import { format } from 'date-fns';

export const formatArmenianDate = (dateString: string): string => {
  try {
    // Date-only values (YYYY-MM-DD) must be parsed as local dates,
    // otherwise timezone conversion can shift the lecturer's chosen day.
    const dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateString);
    if (dateOnly) {
      return `${dateOnly[3]}.${dateOnly[2]}.${dateOnly[1]}`;
    }
    const date = new Date(dateString);
    return format(date, 'dd.MM.yyyy');
  } catch (error) {
    console.error('Error formatting date:', error);
    return dateString;
  }
};


export const formatArmenianDateTime = (dateString: string): string => {
  try {
    const date = new Date(dateString);
    return format(date, 'dd.MM.yyyy HH:mm');
  } catch (error) {
    console.error('Error formatting date time:', error);
    return dateString;
  }
};
